import * as THREE from 'three';
import GradientPlane from './GradienPlane';

export default class GradientController {
    /**
     * @type {Array<GradientPlane>}
     */
    gradients = [];

    /**
     * @type {THREE.WebGLRenderer}
     */
    renderer = new THREE.WebGLRenderer({
        antialias: true,
    });

    /**
     * @type {Boolean}
     */
    isScrolling = false;

    /**
     * @type {Number|undefined}
     */
    scrollTimeout;

    /**
     * @type {Number}
     */
    time = 0;

    /**
     * Setup renderer, start loop and save incstance to window scope
     */
    constructor() {
        window.gradientController = this;
        this.renderer.setScissorTest(true);
        this.addScrollListener();
        this.loop();
    }
    
    /**
     * Scroll listener for setting 
     * value of this.isScrolling boolean variable
     */
    addScrollListener() {
        window.addEventListener('scroll', () => {
            this.isScrolling = true;

            if (this.scrollTimeout) {
                clearTimeout(this.scrollTimeout);
            }

            this.scrollTimeout = setTimeout(() => {
                this.isScrolling = false;
            }, 50);
        });
    }

    /**
     * Add gradient to controller
     * 
     * @param {HTMLElement} el - Gradient HTML element 
     * @returns {GradientPlane} - Instance of gradient
     */
    add(el) {
        if (!el) {
            return false;
        }

        const speed = 0;
        const baseSpeed = el.dataset.baseSpeed ? Number(el.dataset.baseSpeed) : 0.4;
        const color = el.dataset.color ? el.dataset.color.split(',') : [58, 70, 148];
        const gradient = new GradientPlane(el, {
            speed: speed,
            baseSpeed: baseSpeed,
            color: color,
        });

        this.gradients.push(gradient);
        return gradient;
    }

    /**
     * Update gradients, draw them in global renderer 
     * and copy image to single canvases via scissors
     */
    update() {
        /**
         * Fix scroll performance
         */

        this.gradients.forEach(gradient => {
            
            const rect = gradient.element.getBoundingClientRect();
            if (!this.isInViewport(rect)) {        
                return;
            }

            if (!gradient.inited) {
                gradient.init();
                return;
            }
            
            // if (this.isScrolling) {
            //     return;
            // }
            
            gradient.scrollCoeff = 1;

            let { width, height } = rect;
        
            const rendererCanvas = this.renderer.domElement;

            this.renderer.setSize(width, height, false);

            // make sure the canvas for this area is the same size as the area
            if (gradient.ctx.canvas.width !== width || gradient.ctx.canvas.height !== height) {
                gradient.ctx.canvas.width = width;
                gradient.ctx.canvas.height = height;
            }

            this.renderer.setScissor(0, 0, width, height);
            this.renderer.setViewport(0, 0, width, height);

            gradient.render(this.renderer);

            gradient.ctx.globalCompositeOperation = 'copy';
            gradient.ctx.drawImage(
                rendererCanvas,
                0, 
                rendererCanvas.height - height, 
                width,
                height, 
                0, 
                0, 
                width, 
                height
            );
        });
    }

    /**
     * Main loop for update gradients
     */
    loop() {
        this.time += 1;
        if (this.isScrolling && this.time % 4 === 0) {
            this.update();
        }

        if (!this.isScrolling  && this.time % 2 === 0) {
            this.update();
        }
        
        requestAnimationFrame(this.loop.bind(this));
    }

    /**
     * Check if single element is in viewport
     * 
     * @param {DOMRect} rect 
     * @returns {Boolean}
     */
    isInViewport(rect) {
        return (
            rect.top + rect.height >= -1 &&
            rect.top <= (window.innerHeight || document.documentElement.clientHeight )
        );
    }
};